var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox distribution-product-page" },
    [
      _c(
        "el-card",
        {
          staticClass: "filter-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品搜索" } },
                [
                  _c("el-input", {
                    staticClass: "keyword-input",
                    attrs: { clearable: "", placeholder: "商品名称" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.load(1)
                      },
                    },
                    model: {
                      value: _vm.query.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.load(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.reset },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "page-tip" }, [
            _vm._v(
              " 加入并启用后，商品会出现在 App 的淘客专区；商品下架或关闭 App 展示后会自动隐藏。 奖励与参加规格由平台统一配置，本页只看不改 —— 商品要加入淘客专区去「商品库」， 这里可以停用或退出。下表中奖励为 0 的，表示这件商品没有单独配置，按平台默认值发放。 "
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "id", label: "配置ID", width: "75" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品", "min-width": "280" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "product-cell" },
                          [
                            row.image
                              ? _c("el-image", {
                                  staticClass: "product-image",
                                  attrs: { src: row.image, fit: "cover" },
                                })
                              : _vm._e(),
                            _c("div", { staticClass: "product-meta" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "product-name",
                                  attrs: { title: _vm.displayName(row) },
                                },
                                [_vm._v(_vm._s(_vm.displayName(row)))]
                              ),
                              _c("div", { staticClass: "product-id" }, [
                                _vm._v(
                                  "商品ID：" +
                                    _vm._s(row.productId || row.product_id)
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "原始售价（元）", width: "115" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.originPriceText(row)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "参加规格", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        !_vm.scopeCount(row)
                          ? _c("span", { staticClass: "field-tip" }, [
                              _vm._v("全部规格"),
                            ])
                          : _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "warning" } },
                              [_vm._v(_vm._s(_vm.scopeCount(row)) + " 个规格")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "price", label: "售价（元）", width: "105" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sales", label: "销量", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "stock", label: "库存", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { label: "代理奖励", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.rewardText(row, "shareReward", "share_reward")
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "淘客奖励", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.rewardText(
                              row,
                              "partnerReward",
                              "partner_reward"
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "下单送积分", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.pointsText(row)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "可抵扣购物券红包", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.couponDeductText(row)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "下单送购物券红包", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.orderCouponText(row)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "sort", label: "排序", width: "70" },
              }),
              _c("el-table-column", {
                attrs: { label: "淘客状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "启用",
                            "inactive-text": "停用",
                            disabled: !_vm.checkPermi([
                              "merchant:distribution:product:switch",
                            ]),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.toggle(row)
                            },
                          },
                          model: {
                            value: row.commissionOpen,
                            callback: function ($$v) {
                              _vm.$set(row, "commissionOpen", $$v)
                            },
                            expression: "row.commissionOpen",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "125", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm.checkPermi(["merchant:distribution:product:delete"])
                          ? _c(
                              "el-button",
                              {
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.remove(row)
                                  },
                                },
                              },
                              [_vm._v("退出淘客专区")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.query.limit,
              "current-page": _vm.query.page,
              total: _vm.total,
            },
            on: { "size-change": _vm.onSizeChange, "current-change": _vm.load },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }